import React from 'react';

interface ButtonGroupProps {
  className?: string;
  children?: React.ReactNode;
}

function ButtonGroup({ className = '', children }: ButtonGroupProps) {
  return (
    <div className={`join ${className}`.trim()} role="group">
      {children}
    </div>
  );
}

export default ButtonGroup;
